import {rules as v} from '../scripts/rules';

const planumsbeschreibung = {
  "Planumsnr"   : v.isNum,
  
  // 2021-03-31  soll wie "befundbeschreibung/strat. unter" sein
  //"Schnittnr"   : v.isNum,
  "Schnittnr"   : v.isNumManyCommaSeparatedOrEmpty,
  
  "Befundnr"    : v.isNumManyWithoutDash,
  "Profilnr"    : v.isNumManyWithoutDash,
  "Laenge m"    : v.isNumTwoDec,
  "Breite m"    : v.isNumTwoDec,
  "Beschreibung": v.isFreetext,
  "Fotonr"      : v.isNumManyWithoutDash,
  "Datum"       : v.isDate,
  "BearbeiterIn": v.isFreetext,
  "Verworfen"   : v.isJN
}

export default planumsbeschreibung;
